import { render, staticRenderFns } from "./signpeople.vue?vue&type=template&id=39e5c3b9&scoped=true&"
import script from "./signpeople.vue?vue&type=script&lang=js&"
export * from "./signpeople.vue?vue&type=script&lang=js&"
import style0 from "./signpeople.vue?vue&type=style&index=0&id=39e5c3b9&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e5c3b9",
  null
  
)

export default component.exports